import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import './FundList.css';
import ResultRow from './ResultRow.js';
import Modal from 'react-responsive-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ListOptions from './ListOptions.js';
import {
    clearFunds, clearFund, closeExternalLinkModal
} from '../../actions/actions';


// Provides the output table for a single result given one input fund.
class FundList extends PureComponent {

    constructor(props) {
        super(props);
        this.handleClearFunds = this.handleClearFunds.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    // Handle changes to the typed input by the User
    handleClearFunds() {
        // console.log('Clear Funds');
        this.props.clearFunds();
    }

    // Handle close of the Modal
    handleCloseModal = () => {
        // console.log('close the modal');
        this.props.closeExternalLinkModal();
    }

    setTblHeadClass(type) {
        if ((type === this.props.sortColumn) && (this.props.sortDirection === 'DESC')) {
            return ('des')
        } else if ((type === this.props.sortColumn) && (this.props.sortDirection === 'ASC')) {
            return ('asc')
        } else {
            return ('')
        }
    }

    // Render the Capital Gains estimates table
    renderCapGains() {

        // Get the as of date from the inputFund's latest levels date
        var asOfDate = new Date(this.props.fundData.fundsToCompare[0].inputFund.levels.date.slice(-1)[0]).toLocaleDateString();

        return (

            <thead>
                <tr>
                    <th colSpan='1' scope='colgroup' ></th>
                    <th colSpan='1' scope='colgroup' className='hidden-xs'></th>
                    <th colSpan='1' scope='colgroup' className='center'></th>
                    <th colSpan='1' scope='colgroup' className='center'></th>
                    <th colSpan='3' scope='colgroup' className='center borderleft borderbottom'>Estimated Capital Gains / Share</th>
                    <th colSpan='1' scope='colgroup' className='center borderleft'></th>
                    <th colSpan='1' scope='colgroup' className='center borderleft'></th>
                </tr>
                <tr>
                    <th scope='col' className='left' >Ticker</th>
                    <th scope='col' className='left hidden-xs' >Fund Name</th>
                    <th scope='col' className='center' >Ex-Date</th>
                    <th scope='col' className='center' >Payable Date</th>
                    <th scope='col' className='center borderleft' >Short-Term</th>
                    <th scope='col' className='center' >Long-Term</th>
                    <th scope='col' className='center' >Total</th>
                    <th scope='col' className='center borderleft' >Total Capital Gain / NAV <br />(NAVs as of {asOfDate})</th>
                    <th scope='col' className='action center borderleft' onClick={this.handleClearFunds}>✕</th>
                </tr>
            </thead>
        );

    }


    // Footnote under Cap Gains table
    renderCapGainsFootnote() {

        return (
            <div>
                <br />
            </div>
        );

    }

    // Render the standardized performance table
    renderPerformance() {

        // Get the as of date from the inputFund's latest levels date
        var asOfDate = new Date(this.props.fundData.fundsToCompare[0].inputFund.stdPerformance[0].asOfDate).toLocaleDateString();

        return (
            <thead>
                <tr>
                    <th colSpan='1' scope='colgroup' ></th>
                    <th colSpan='1' scope='colgroup' className='hidden-xs' ></th>
                    <th colSpan='3' scope='colgroup' className='center borderleft borderbottom'>Cumulative Returns<br />(As of {asOfDate})</th>
                    <th colSpan='5' scope='colgroup' className='center borderleft borderbottom'>Average Annual Total Returns<br />(As of {asOfDate})</th>
                    <th colSpan='1' scope='colgroup' className='center borderleft'></th>
                </tr>
                <tr>
                    <th scope='col' className='left' >Ticker</th>
                    <th scope='col' className='left hidden-xs' >Fund Name</th>
                    <th scope='col' className='center borderleft' >1-Month</th>
                    <th scope='col' className='center' >3-Month</th>
                    <th scope='col' className='center' >YTD</th>
                    <th scope='col' className='center borderleft' >1-Year</th>
                    <th scope='col' className='center' >3-Year</th>
                    <th scope='col' className='center' >5-Year</th>
                    <th scope='col' className='center' >10-Year</th>
                    <th scope='col' className='center' >Since Inception</th>
                    <th scope='col' className='action center borderleft' onClick={this.handleClearFunds}>✕</th>
                </tr>
            </thead>
        );

    }

    // Footnote under performance table
    renderPerformanceFootnote() {

        return (
            <div>
                <br />
                <div className='introtext'>
                    Performance is historical and does not guarantee future results.
                    Current performance may be lower or higher than quoted.
                    Investment returns and principal value of an investment will fluctuate so that an investor's shares,
                    when redeemed, may be worth more or less than their original cost. Performance data of the funds
                    for the most recent month-end is available at the website links provided in the Fund Details section.
                    Returns of less than one year are cumulative.
                </div>
                <div className='introtext'>
                    WisdomTree shares are bought and sold at market price (not NAV) and are not individually
                    redeemed from the Fund. Total Returns are calculated using the daily 4:00 p.m. EST net asset
                    value (NAV). Market price returns reflect the midpoint of the bid/ask spread as of the close
                    of trading on the exchange where Fund shares are listed. Market price returns do not represent
                    the returns you would receive if you traded shares at other times.
                </div>
                <div className='introtext'>
                    Prospectuses and other important regulatory documents for the individual funds can be found by clicking on the hyperlink provided in the Fund Details section.
                </div>
            </div>
        );

    }

    // Render the fund details table
    renderFundDetails() {

        // Get the as of date from the inputFund's latest levels date
        var asOfDate = new Date(this.props.fundData.fundsToCompare[0].inputFund.stdPerformance[0].asOfDate).toLocaleDateString();

        return (
            <thead>
                <tr className='first'>
                    <th scope='col' className='left' >Ticker</th>
                    <th scope='col' className='center' >Website</th>
                    <th scope='col' className='center' >Filings</th>
                    <th scope='col' className='center' >Inception Date</th>
                    <th scope='col' className='center' >Gross Expense Ratio</th>
                    <th scope='col' className='center' >Net Expense Ratio</th>
                    <th scope='col' className='center' >30-Day SEC Yield, Subsidized (as of {asOfDate})</th>
                    <th scope='col' className='center' >30-Day SEC Yield, Unsubsidized (as of {asOfDate})</th>
                    <th scope='col' className='center col-md-3'>Notes</th>
                    <th scope='col' className='action center borderleft' onClick={this.handleClearFunds}>✕</th>
                </tr>
            </thead>
        );

    }


    // Footnote under Fund Details table
    renderFundDetailsFootnote() {

        return (
            <div>
                <br />
                <div className='introtext'>
                    Performance is historical and does not guarantee future results. Current performance
                    may be lower or higher than quoted. Investment returns and principal value of an
                    investment will fluctuate so that an investor's shares, when redeemed, may be worth
                    more or less than their original cost. The most recent month end performance data of the funds
                    can be found on the individual fund’s website. For this and other important information,
                    please click on the hyperlinks provided in the 'Website' column.
                </div>
                <div className='introtext'>
                    Prospectuses and other important regulatory documents for the individual funds can be found by clicking on the hyperlink provided in the 'Filings' column.
                </div>
            </div>
        );

    }


    // Render the Table head based on type of table
    renderTableHeader(fundListType) {

        switch (fundListType) {

            case 'capgains':
                return (this.renderCapGains());
            case 'performance':
                return (this.renderPerformance());
            case 'funddetails':
                return (this.renderFundDetails());
            default:
                break;
        }
    }

    // Render the Table head based on type of table
    renderTableFootnote(fundListType) {

        switch (fundListType) {

            case 'capgains':
                return (this.renderCapGainsFootnote());
            case 'performance':
                return (this.renderPerformanceFootnote());
            case 'funddetails':
                return (this.renderFundDetailsFootnote());
            default:
                break;
        }
    }

    render() {

        if (this.props.fundData.loadingMessage) {
            return (
                <div className='fundlist'>
                    <div className='loading-spinner'>
                        <FontAwesomeIcon icon="circle-notch" size="4x" style={{ color: '#050139' }} spin />
                    </div>
                </div>
            )
        }
        else if (this.props.fundData.fundsToCompare && this.props.fundData.fundsToCompare.length > 0) {

            return (
                <div className='fundlist'>
                    <div className='row'>&nbsp;</div>
                    <ListOptions />
                    <div>
                        <div className='table-responsive'>
                            <table id='table-to-xls' className='tableCap'>

                                {this.renderTableHeader(this.props.fundData.fundListType)}

                                {/* Add the table body for all rows, depending on the type */}
                                <tbody>
                                    {this.props.fundData.fundsToCompare.map((result, index) => {
                                        return (<ResultRow key={index} result={result} fundListType={this.props.fundData.fundListType} />);
                                    })}

                                </tbody>
                            </table>
                        </div>
                        {this.renderTableFootnote(this.props.fundData.fundListType)}

                        {this.props.fundData.externalModalURL ?
                            <Modal open={this.props.fundData.externalModalURL !== null} onClose={this.handleCloseModal}
                                classNames={{ overlay: 'custom-overlay', modal: 'custom-modal', closeIcon: 'custom-closeIcon' }} center>
                                <div>
                                    <h4>You are now leaving the WisdomTree Website</h4>
                                </div>
                                <div>
                                    Hyperlinks on this website are provided as a convenience and we disclaim any responsibility for information,
                                    services or products found on the websites linked hereto.
                                </div>
                                <div>
                                    <a href={this.props.fundData.externalModalURL}
                                        target='_blank' onClick={this.handleCloseModal}>
                                        Click here to continue
                                    </a>
                                </div>
                            </Modal>
                            : null}

                    </div>
                </div>
            );

        } else {
            return null;
        }
    }

}

function mapStateToProps(state) {
    return {
        fundData: state.fundData
    };
}


export default connect(mapStateToProps, { clearFunds, clearFund, closeExternalLinkModal })(FundList);